"use strict";
import React from "react";
export default function NotificationCtaButton(props) {
  return /* @__PURE__ */ React.createElement(
    "button",
    {
      "data-component": "NotificationCtaButton",
      className: "button--link-v2 button-small mb-0",
      onClick: props.onClick
    },
    props.children
  );
}
